import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select } from 'antd';
import axios from 'axios';
import Configuration from '../../Configuration';
const Step = Steps.Step;
const Option = Select.Option;

class TagModal extends Component {
  constructor(props) {
    super(props);

    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.steps = {step0: {tag_number: false, kind: false}, step1: {profile_id: false}, step2: {car_id: true}};
    this.state = {step: 0, stepLimit: 2, stepValidation: this.steps, tag: {}, profiles: [], cars: []};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleTagNumber = this.handleTagNumber.bind(this);
    this.handleKind = this.handleKind.bind(this);
    this.handleProfile = this.handleProfile.bind(this);
    this.handleCar = this.handleCar.bind(this);
    this.setProp = this.setProp.bind(this);
    this.validateStep = this.validateStep.bind(this);
  }

  componentDidMount() {
    this.getProfiles();
  }

  getProfiles() {
    axios.get(`${Configuration.apiServer}/api/v1/profiles`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      this.setState({profiles: resp.data});
    });
  }

  getEmployeeCars(id) {
    axios.get(`${Configuration.apiServer}/api/v1/cars/${id}/employee`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      this.setState({cars: resp.data});
    });
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar los campos obligatorios');

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.tag);
      this.setState({validation: true, tag: {}, step: 0});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }

      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  handleTagNumber(event) {
    this.setProp('tag_number', event.target.value);
  }

  handleKind(value) {
    const validations = this.state.stepValidation;
    if(value === 'car') {
      validations['step2']['car_id'] = false;
    } else { 
      validations['step2']['car_id'] = true;
    }

    this.setState({stepValidation: validations});
    this.setProp('kind', value);
  }

  handleCar(value) {
    this.setProp('car_id', value);
  }

  handleProfile(value) {
    this.setProp('profile_id', value);
    this.getEmployeeCars(value);
  }

  setProp(prop, value) {
    let tag = this.state.tag;
    let validation = this.state.stepValidation;
    tag[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({tag: tag, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // List profiles
    const profiles = this.state.profiles.map(profile => {
      return (
        <Option value={profile.id} key={`profile:${profile.id}`}>{profile.names}</Option>
      );
    });
    
    // List employee cars
    const cars = this.state.cars.map(car => {
      return (
        <Option value={car.id} key={`car:${car.id}`}>({car.plate}) {car.details}</Option>
      );
    });

    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Tag" />
            <Step title="Empleado" />
            <Step title="Auto" />
          </Steps>
        </div>

        <br/> <br/>
        
        {/* Step 1 */}
        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Número de Tag</label>
              <input type="text" className="form-control" defaultValue={this.props.current.plate} placeholder="10101" onChange={this.handleTagNumber} />
            </div>

            <div className="form-group">
              <label>Tipo de Tag</label>
              <Select
                onChange={this.handleKind}
                style={{ width: '100%' }}
              >
                <Option value="car">Para Auto</Option>
                <Option value="walking">Para Peatonal</Option>
              </Select>
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(1) }}>
            <div className="form-group">
              <label>Selecciona un empleado</label>
              <Select
                showSearch
                onChange={this.handleProfile}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {profiles}
              </Select>
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(2) }}>
            <div className="form-group">
              <label>Selecciona un auto</label>
              <Select
                showSearch
                onChange={this.handleCar}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {cars}
              </Select>
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default TagModal;



// WEBPACK FOOTER //
// ./src/components/modals/TagModal.js